"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var guildMarkColors = ["#DF3232", "#32DE32", "#3232DE", "#DEDE32", "#DE32DE", "#32DEDE", "#FEA3A3", "#97F397", "#9797F3", "#F3F397", "#F397F3", "#97F3F3", "#FFFFFF", "#B6B6B6", "#000000", "#FF0000", "#FF6600", "#FFFF00", "#00FF00", "#0000FF", "#323297", "#820282", "#00FFFF", "#FECB02"];
var _default = guildMarkColors;
exports.default = _default;